jQuery(document).ready(function($){

    $('.js-accordion-header').click(function(){

        var $content =  $(this).next('.js-accordion-content');
        $content.slideToggle();
        $(this).toggleClass('active');

    });
});

